// src/routes/StudentRoute.js
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const StudentRoute = ({ children }) => {
  const { isAuthenticated, role } = useContext(AuthContext);
  const location = useLocation();

  if (!isAuthenticated() || role !== "student") {
    return <Navigate to="/" replace state={{ from: location }} />;
  }
  return children;
};

export default StudentRoute;
